import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_xlsx_export_modal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "exportXlsxModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Download Excel Report")
], -1)
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "row",
  style: {"margin-bottom":"25px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "fw-bold form-label",
  for: "selectYearXlsx"
}, " Export Year: ", -1)
const _hoisted_8 = ["value", "label"]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "fw-bold form-label",
  for: "selectYearXlsx"
}, " Report Type: ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "iii"
}, " Inclusion Impact Index ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "sp" }, " Inclusion Plus ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "iii-sp" }, " General ", -1)
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "card-footer d-flex justify-content-end" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedYear) = $event)),
              id: "selectYearXlsx",
              class: "form-control"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearsList, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item,
                  label: item
                }, null, 8, _hoisted_8))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedYear]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedReportType) = $event)),
              class: "form-control",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeReportType()))
            }, _hoisted_14, 544), [
              [_vModelSelect, _ctx.selectedReportType]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-white",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onHideModal && _ctx.onHideModal(...args)))
          }, _toDisplayString(_ctx.translate("BUTTON_CLOSE")), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-dark-blue",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmitModal && _ctx.onSubmitModal(...args)))
          }, [
            (_ctx.spinnerDownloadVisible)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_18))
              : _createCommentVNode("", true),
            _createTextVNode(" Download ")
          ])
        ])
      ])
    ])
  ], 512))
}